<!-- 招投标项目列表公共壳：「我的招标」（带 2 个 tab）与「全部招标」共用 -->
<template>
  <ContentWrap>
    <!-- 搜索工作栏 -->
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="90px"
    >
      <el-form-item label="关键字" prop="keyword">
        <el-input
          v-model="queryParams.keyword"
          class="!w-240px"
          clearable
          placeholder="关键字/申请人/单号"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="甲方名称" prop="customerId">
        <el-select
          v-model="queryParams.customerId"
          class="!w-200px"
          clearable
          filterable
          placeholder="请选择甲方"
        >
          <el-option
            v-for="item in customerList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="对应产品" prop="productId">
        <el-select
          v-model="queryParams.productId"
          class="!w-200px"
          clearable
          filterable
          placeholder="请选择产品"
        >
          <el-option
            v-for="item in productList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="开发语言" prop="devLanguage">
        <el-select
          v-model="queryParams.devLanguage"
          class="!w-200px"
          clearable
          placeholder="请选择开发语言"
        >
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.CRM_BID_DEV_LANGUAGE)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="项目状态" prop="projectStatus">
        <el-input
          v-model="queryParams.projectStatus"
          class="!w-200px"
          clearable
          placeholder="请输入项目状态"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item v-if="showCreatorFilter" label="人员" prop="creator">
        <el-select
          v-model="queryParams.creator"
          class="!w-200px"
          clearable
          filterable
          placeholder="请选择申请人"
        >
          <el-option
            v-for="item in userOptions"
            :key="item.id"
            :label="item.nickname"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="获标时间" prop="winTimes">
        <el-date-picker
          v-model="queryParams.winTimes"
          :default-time="defaultTime"
          class="!w-360px"
          end-placeholder="结束日期"
          range-separator="-"
          start-placeholder="开始日期"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['crm:bid-project:create']"
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
        <el-button
          v-hasPermi="['crm:bid-project:export']"
          :loading="exportLoading"
          plain
          type="success"
          @click="handleExport"
        >
          <Icon class="mr-5px" icon="ep:download" />
          导出
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <!-- 列表 -->
  <ContentWrap>
    <el-tabs v-if="showTabs" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="我的招标" name="1" />
      <el-tab-pane label="我下属的" name="3" />
    </el-tabs>

    <el-table v-loading="loading" :data="list" :show-overflow-tooltip="true" :stripe="true">
      <el-table-column align="center" fixed="left" label="甲方名称" prop="customerName" width="180">
        <template #default="scope">
          <el-link
            v-if="scope.row.customerId"
            :underline="false"
            type="primary"
            @click="openCustomerDetail(scope.row.customerId)"
          >
            {{ scope.row.customerName }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column align="center" label="项目名称" prop="projectName" width="200" />
      <el-table-column align="center" label="对应产品" prop="productName" width="160" />
      <el-table-column align="center" label="开发语言" prop="devLanguage" width="110">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.CRM_BID_DEV_LANGUAGE" :value="scope.row.devLanguage" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="项目编号" prop="projectNo" width="140" />
      <el-table-column align="center" label="单号" prop="no" width="170" />
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="获标时间"
        prop="winTime"
        width="180"
      />
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="获标截止时间"
        prop="winDeadline"
        width="180"
      />
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="投标截止时间"
        prop="bidDeadline"
        width="180"
      />
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="述标时间"
        prop="presentTime"
        width="180"
      />
      <el-table-column align="center" label="达标要求" prop="reachRequirement" width="220" />
      <el-table-column align="center" label="达标地点" prop="reachPlace" width="180" />
      <el-table-column align="center" label="标书费用" prop="bookFee" width="120" />
      <el-table-column align="center" label="项目预算" prop="projectBudget" width="140" />
      <el-table-column align="center" label="项目周期" prop="projectCycle" width="120" />
      <el-table-column align="center" label="保证金" prop="deposit" width="120" />
      <el-table-column align="center" label="项目状态" prop="projectStatus" width="180" />
      <el-table-column align="center" label="申请人" prop="creatorName" width="110" />
      <el-table-column
        align="center"
        fixed="right"
        :show-overflow-tooltip="false"
        label="操作"
        width="120"
      >
        <template #default="scope">
          <div class="crm-bid-action">
            <el-button
              v-hasPermi="['crm:bid-project:update']"
              link
              type="primary"
              @click="openForm('update', scope.row.id)"
            >
              编辑
            </el-button>
            <el-button
              v-hasPermi="['crm:bid-project:delete']"
              link
              type="danger"
              @click="handleDelete(scope.row.id)"
            >
              删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <!-- 表单弹窗：添加/修改 -->
  <BidProjectForm ref="formRef" @success="getList" />
</template>

<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { dateFormatter } from '@/utils/formatTime'
import download from '@/utils/download'
import { BidProjectApi, BidProjectVO } from '@/api/crm/bidProject'
import * as CustomerApi from '@/api/crm/customer'
import * as ProductApi from '@/api/crm/product'
import * as UserApi from '@/api/system/user'
import { TabsPaneContext } from 'element-plus'
import BidProjectForm from './BidProjectForm.vue'

const props = withDefaults(
  defineProps<{
    /** 是否展示「我的招标 / 我下属的」2 个 tab */
    showTabs?: boolean
    /** 是否展示「人员」筛选 */
    showCreatorFilter?: boolean
  }>(),
  {
    showTabs: false,
    showCreatorFilter: false
  }
)

const message = useMessage() // 消息弹窗
const { t } = useI18n() // 国际化

const loading = ref(true) // 列表的加载中
const total = ref(0) // 列表的总页数
const list = ref<BidProjectVO[]>([]) // 列表的数据
const customerList = ref<any[]>([]) // 客户（甲方）下拉
const productList = ref<any[]>([]) // 产品下拉
const userOptions = ref<UserApi.UserVO[]>([]) // 用户下拉（人员筛选）
const exportLoading = ref(false) // 导出的加载中
const activeName = ref('1') // 列表 tab
/** 日期范围默认带时分秒 00:00:00 ~ 23:59:59 */
const defaultTime = [new Date(2000, 0, 1, 0, 0, 0), new Date(2000, 0, 1, 23, 59, 59)]

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 10,
  // 关键字：单号 / 项目名称 / 项目编号 / 项目状态
  keyword: undefined,
  customerId: undefined,
  productId: undefined,
  devLanguage: undefined,
  projectStatus: undefined,
  creator: undefined,
  winTimes: [],
  // ★ 必须与 activeName 的初值 '1' 保持一致。若留 undefined，qs 序列化会**丢弃该参数**，
  //   后端 sceneType=null 即「不做数据权限过滤」，会把别人的招标也查出来。
  //   「全部招标」页（showTabs=false）不传该参数，后端即返回全量。
  sceneType: props.showTabs ? '1' : undefined
})
const queryFormRef = ref() // 搜索的表单

/** tab 切换：我的招标(1) / 我下属的(3) */
const handleTabClick = (tab: TabsPaneContext) => {
  const paneName = tab.paneName as string
  activeName.value = paneName
  queryParams.sceneType = paneName
  handleQuery()
}

/** 查询列表 */
const getList = async () => {
  loading.value = true
  try {
    const data = await BidProjectApi.getBidProjectPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

/** 搜索按钮操作 */
const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

/** 重置按钮操作 */
const resetQuery = () => {
  queryFormRef.value.resetFields()
  queryParams.keyword = undefined
  queryParams.customerId = undefined
  queryParams.productId = undefined
  queryParams.devLanguage = undefined
  queryParams.projectStatus = undefined
  queryParams.creator = undefined
  queryParams.winTimes = []
  handleQuery()
}

/** 添加/修改操作 */
const formRef = ref<InstanceType<typeof BidProjectForm>>()
const openForm = (type: string, id?: number) => {
  formRef.value?.open(type, id)
}

/** 删除按钮操作 */
const handleDelete = async (id: number) => {
  try {
    // 删除的二次确认
    await message.delConfirm()
    // 发起删除
    await BidProjectApi.deleteBidProject(id)
    message.success(t('common.delSuccess'))
    // 刷新列表
    await getList()
  } catch {}
}

/** 导出按钮操作 */
const handleExport = async () => {
  try {
    // 导出的二次确认
    await message.exportConfirm()
    // 发起导出
    exportLoading.value = true
    const data = await BidProjectApi.exportBidProject(queryParams)
    download.excel(data, '招投标项目.xlsx')
  } catch {
  } finally {
    exportLoading.value = false
  }
}

/** 打开客户详情 */
const { push } = useRouter()
const openCustomerDetail = (id: number) => {
  push({ name: 'CrmCustomerDetail', params: { id } })
}

/** 初始化 **/
onMounted(async () => {
  customerList.value = await CustomerApi.getCustomerSimpleList()
  productList.value = await ProductApi.getProductSimpleList()
  userOptions.value = await UserApi.getSimpleUserList()
  await getList()
})
</script>

<style lang="scss" scoped>
.crm-bid-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  :deep(.el-button + .el-button) {
    margin-left: 0;
  }
}
</style>
